import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import HomeOne from './HomeOne'
import CategoryVideosPage from './CategoryVideosPage'
import VideoShowcasePage from './VideoShowcasePage'
import LoadTop from '../Components/LoadTop'
import { AdminAuthProvider } from '../context/AdminAuthContext'
import ProtectedAdminRoute from '../Components/Admin/ProtectedAdminRoute'
import AdminLayout from '../Components/Admin/AdminLayout'
import AdminLogin from './Admin/AdminLogin'
import AdminDashboard from './Admin/AdminDashboard'
import AdminGallery from './Admin/AdminGallery'
import AdminVideos from './Admin/AdminVideos'
import AdminReviews from './Admin/AdminReviews'

function RouterPage() {
  return (
    <div>
      <Router>
        <AdminAuthProvider>
          <LoadTop />
          <Routes>
            <Route path="/" element={<HomeOne />} />
            <Route path="/videos" element={<VideoShowcasePage />} />
            <Route path="/travel-with-dinesh" element={<CategoryVideosPage />} />
            <Route path="/ape-pansala" element={<CategoryVideosPage />} />
            <Route path="/urumaya" element={<CategoryVideosPage />} />
            <Route path="/ranga-rata" element={<CategoryVideosPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedAdminRoute>
                  <AdminLayout />
                </ProtectedAdminRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="gallery" element={<AdminGallery />} />
              <Route path="videos/:categorySlug" element={<AdminVideos />} />
              <Route path="videos" element={<AdminVideos />} />
              <Route path="reviews" element={<AdminReviews />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AdminAuthProvider>
      </Router>
    </div>
  )
}

export default RouterPage
